// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"87":"2a7f0e36","375":"3b9127ec","474":"945e810b","519":"56cc8162","659":"8fc36f58","787":"d59f7c13"}[chunkId] + ".chunk.js";
};